<template>
  <Login/>
</template>
<script>
import Login from 'place/login/login.vue'
export default {
    components:{
      Login
    }
}
</script>